import { ColliTriggerName } from '@frontend/colli/types';
import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useColliTriggerSelect from '././colli-trigger-select.controller';

const ID = 'colli-trigger-select';
export interface ColliTriggerSelectProps extends Omit<SelectInputV2Props<ColliTriggerName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const ColliTriggerSelect = (props: ColliTriggerSelectProps) => {
    const viewProps = useColliTriggerSelect(props);

    return (
        <SelectInputV2<ColliTriggerName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Colli trigger'}
            options={viewProps.options}
        />
    );
};
